import {Pressable, Text, View} from 'native-base';
import React from 'react';

import {useIsMD} from 'hooks/useIsMD';

export interface PreferenceSelectorItemProps {
  isSelected: boolean;
  onSelect: () => void;
  value: string | undefined;
  label: string;
}

const PreferenceSelectorItem: React.FunctionComponent<
  PreferenceSelectorItemProps
> = (props) => {
  const {label, isSelected, onSelect, value} = props;

  const isMD = useIsMD();

  return (
    <Pressable
      testID={`preference-item-${label.toLowerCase()}`}
      onPress={onSelect}
      p="24px"
      borderRadius="8px"
      borderWidth="1px"
      borderColor={isSelected ? '#298ACF' : '#BEC0C5'}
      bgColor={isSelected ? 'rgba(7,120,195,0.1)' : 'white'}
      flexDirection="row"
    >
      <View mr="16px" pt="3px">
        <View
          w="16px"
          h="16px"
          borderRadius="100px"
          borderWidth="1px"
          borderColor={isSelected ? '#0778C3' : '#BEC0C5'}
          alignItems="center"
          justifyContent="center"
        >
          {isSelected && (
            <View h="8px" w="8px" borderRadius="50px" bgColor="#0778C3" />
          )}
        </View>
      </View>
      <View alignItems="center" flex={1} mr={isMD ? '32px' : undefined}>
        <View flexWrap="wrap" mb={undefined} flexDirection="row">
          <Text color={'rgb(52, 56, 64)'} mr="5px" fontFamily="body">
            {label}:
          </Text>
          <Text color={'rgb(52, 56, 64)'} fontFamily="body" fontWeight="bold">
            {value}
          </Text>
        </View>
      </View>
    </Pressable>
  );
};

export default PreferenceSelectorItem;
